module fdm.common {
    declare var screenfull: any;

    export class FullScreenButtonController {
        target: string;
        isHeaderIcon: boolean;

        toggleFullScreen() {
            if (this.target) {
                const targetElement = angular.element(this.target)[0];
                // screenfull.toggle(targetElement);
                if (targetElement.requestFullscreen) {
                    targetElement.requestFullscreen();
                }
            }
        }

    }

    angular.module('fdm.common')
        .component('fullScreenButton', {
            bindings: {
                target: '@',
                isHeaderIcon: "<"
            },
            controller: (FullScreenButtonController as any),
            templateUrl: '/app/src/common/full-screen-button.html'
        });
}